import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { formatEndpoint } from '@omnipresentgroup/helpers';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import {
  DEFAULT_TIME_OFF_COMPANY_RESPONSE,
  DEFAULT_TIME_OFF_RESPONSE,
  DEFAULT_TIME_OFF_TYPES,
} from './fixtures';

export const timeOffsHandlers = [
  http.get(formatEndpoint(`${API_PATH}/by-employee-id/:id/requests`), () =>
    HttpResponse.json(DEFAULT_TIME_OFF_RESPONSE),
  ),
  http.get(formatEndpoint(`${API_PATH}/by-company-id/:id/requests`), () =>
    HttpResponse.json(DEFAULT_TIME_OFF_COMPANY_RESPONSE),
  ),
  http.delete(formatEndpoint(`${API_PATH}/requests/:id`), () => {
    return HttpResponse.json({}, { status: HTTPStatusCodes.OK });
  }),
  http.get(formatEndpoint(`${API_PATH}/types`), () => {
    return HttpResponse.json(DEFAULT_TIME_OFF_TYPES, {
      status: HTTPStatusCodes.OK,
    });
  }),
];
